// Single Responsibility: Display AI Goal Information
import React from 'react';
import { AIGoal } from '../../types/ai';

interface AIGoalCardProps {
  goal: AIGoal;
  index: number;
}

export const AIGoalCard: React.FC<AIGoalCardProps> = ({ goal, index }) => {
  const getComplexity = (): string => {
    const complexity = goal.complexityScore || goal.complexity;
    return complexity ? `${complexity}/10` : 'N/A';
  };

  return (
    <div className="p-3 bg-gray-50 rounded-lg">
      <h5 className="font-medium text-gray-900">
        {goal.name || `Unnamed Goal ${index + 1}`}
      </h5>
      <p className="text-sm text-gray-600 mt-1">
        {goal.description || 'No description available'}
      </p>
      <div className="flex gap-3 mt-2 text-xs text-gray-500">
        <span>Complexity: {getComplexity()}</span>
        {goal.estimatedHours && (
          <span>{goal.estimatedHours}h estimated</span>
        )}
        {goal.standalonePotential && (
          <span className="text-amber-600 font-medium">Standalone Potential</span>
        )}
      </div>
      {goal.aiReasoning && (
        <div className="mt-2 p-2 bg-blue-50 rounded text-xs text-blue-700">
          <strong>AI Reasoning:</strong> {goal.aiReasoning}
        </div>
      )}
    </div>
  );
};